import { render } from "./PlayableCard.vue?vue&type=template&id=807ea7b8"
import script from "./PlayableCard.vue?vue&type=script&lang=js"
export * from "./PlayableCard.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__